<script lang="ts">
  // Débit instantané dans le temps (descendant et montant).
  let { down = [], up = [] }: { down?: number[]; up?: number[] } = $props();
  const W = 600;
  const H = 140;
  // Lissage sur 500 ms (5 échantillons) : la progression de l'envoi arrive par à-coups dans le navigateur.
  const smooth = (s: number[], n = 5) => s.map((_, i) => {
    const w = s.slice(Math.max(0, i - n + 1), i + 1);
    return w.reduce((a, b) => a + b, 0) / w.length;
  });
  const sDown = $derived(smooth(down));
  const sUp = $derived(smooth(up, 10)); // envoi : progression par à-coups, lissage sur 1 s
  const maxV = $derived(Math.max(1, ...sDown, ...sUp) * 1.1);
  const n = $derived(Math.max(150, down.length, up.length));
  const path = (s: number[]) =>
    s.length < 2 ? '' : 'M' + s.map((v, i) => `${((i / (n - 1)) * W).toFixed(1)},${(H - (v / maxV) * H).toFixed(1)}`).join('L');
  // Surface sous la courbe (dégradé vers le transparent)
  const area = (s: number[]) => (s.length < 2 ? '' : `${path(s)}L${(((s.length - 1) / (n - 1)) * W).toFixed(1)},${H}L0,${H}Z`);
</script>

<figure>
  <svg viewBox="0 0 {W} {H + 4}" preserveAspectRatio="none" role="img" aria-label="Évolution du débit pendant le test">
    <defs>
      <linearGradient id="aire-d" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="var(--down)" stop-opacity=".35" /><stop offset="1" stop-color="var(--down)" stop-opacity="0" /></linearGradient>
      <linearGradient id="aire-u" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="var(--up)" stop-opacity=".3" /><stop offset="1" stop-color="var(--up)" stop-opacity="0" /></linearGradient>
    </defs>
    {#each [0.25, 0.5, 0.75] as g}<line x1="0" x2={W} y1={H * g} y2={H * g} stroke="var(--border)" stroke-dasharray="3 6" vector-effect="non-scaling-stroke" />{/each}
    <line x1="0" x2={W} y1={H} y2={H} stroke="var(--border)" />
    <path d={area(sDown)} fill="url(#aire-d)" />
    <path d={area(sUp)} fill="url(#aire-u)" />
    <path d={path(sDown)} fill="none" stroke="var(--down)" stroke-width="2.5" vector-effect="non-scaling-stroke" style="filter: drop-shadow(0 0 6px var(--down))" />
    <path d={path(sUp)} fill="none" stroke="var(--up)" stroke-width="2.5" vector-effect="non-scaling-stroke" style="filter: drop-shadow(0 0 6px var(--up))" />
  </svg>
  <figcaption class="small muted">
    <span class="key" style="--c: var(--down)"></span> descendant <span class="key" style="--c: var(--up)"></span> montant — échelle max {Math.round(maxV)} Mbit/s
  </figcaption>
</figure>

<style>
  figure { margin: 0; }
  svg { width: 100%; height: 130px; display: block; overflow: visible; }
  .key { display: inline-block; width: 14px; height: 4px; background: var(--c); box-shadow: 0 0 8px var(--c); border-radius: 2px; vertical-align: middle; margin: 0 .3rem 0 .6rem; }
</style>
